module.exports = __webpack_public_path__ + "img/erro-500.575fdbb7.png";